module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_19.215ab818.pdf";